<script>
  import { onMount, afterUpdate } from "svelte";
  import { smoothScroll } from "smooth-scroll-anchor";
  // Any { named } exports from a commonJS module get borked by rollup unless you specify in config!
  // import { toggleCloseSet } from "../../common/dist/ToggleTargets";
  export let innerHTML;
  export let usingAdvancedSearch;
  export let usingAlgolia;
  export let indexName;
  let itemsGrouped = [];
  try {
    // Get the link items that are passed in serialised and sort them appropriately ready for rendering as a big sexy A-Z list
    if (!innerHTML) {
      throw new Error("No items");
    }
    let items = JSON.parse(innerHTML);
    // Sort alphabetical by their letter value
    items = items.sort((a, b) => (a.letter < b.letter ? -1 : 1));
    // If advanced search, ignore the provided URLs and point to the approp search results page
    if (usingAdvancedSearch) {
      items = items.map((item) => {
        // /search?fsa=%7B%22vendor%22%3A%5B%22Apex%20Energetics%20-%20K-Line%20Nutritionals%22%5D%7D
        item.url = `/search?fsa=${encodeURIComponent(
          JSON.stringify({ vendor: [item.title] })
        )}`;
        return item;
      });
    } else if (usingAlgolia && indexName) {
      // /search?[indexName]%5BrefinementList%5D%5Bvendor%5D%5B0%5D=Mega%20Cortex
      items = items.map((item) => {
        item.url = encodeURI(
          `/search?${indexName}[refinementList][vendor][0]=${item.title}`
        );
        return item;
      });
    }
    // console.log(items);
    let itemsAlpha = [];
    items.forEach((item) => {
      let { letter } = item;
      if (!"abcdefghijklmnopqrstuvwxyz".includes(letter)) {
        letter = "0-9"; // i.e. 0-9 or other
      }
      itemsAlpha[letter] = !itemsAlpha[letter] ? [] : itemsAlpha[letter];
      itemsAlpha[letter].push(item);
    });
    for (let letter in itemsAlpha) {
      itemsGrouped.push({
        letter,
        items: itemsAlpha[letter],
      });
    }
    // console.log(itemsGrouped);
  } catch (e) {
    console.error("items: ", e);
  }
  // When mounted and rendered, check the URL for an anchor link and scroll to it
  // (as this won't work automatically, what with the render happening after load.. damn browsers)
  const scrollUsingHash = () => {
    if (window.location.hash) {
      // https://stackoverflow.com/a/47988441
      // if ("scrollRestoration" in window.history) {
      //   window.history.scrollRestoration = "manual";
      // }
      const scrollToGroup = window.location.hash.substr(1);
      const target = document.getElementById(scrollToGroup);
      if (target) {
        smoothScroll(target, {
          behaviour: "smooth",
          block: "start",
          offset: 90,
        });
      }
    }
  };
  const anchorLinksOnPage = document.querySelectorAll('[href*="#group-"]');
  anchorLinksOnPage &&
    anchorLinksOnPage.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.stopPropagation();
        // Close nav
        // This is hamfisted and probably will come back to haunt me, but..
        const navToggles = document.querySelectorAll(
          "header [data-toggle-target]"
        );
        if (navToggles) {
          navToggles.forEach((toggle) => {
            toggle.classList.remove("active");
            document
              .querySelector(toggle.getAttribute("data-toggle-target"))
              .classList.remove("active");
          });
        }
        // smooth scroll
        scrollUsingHash();
      });
    });
  // Only attempt this the once, in case it triggers for some random other reason
  let scrollAttempt = false;
  afterUpdate(async () => {
    if (!scrollAttempt) {
      scrollAttempt = true;
    }
  });
</script>

{#if itemsGrouped}
  <article class="az-groups">
    {#each itemsGrouped as group}
      <section class="az-group" id={`group-${group.letter.toUpperCase()}`}>
        <h2>{group.letter.toUpperCase()}</h2>
        <ul>
          {#each group.items as item}
            <li>
              <a href={item.url}>{item.title}</a>
            </li>
          {/each}
        </ul>
      </section>
    {/each}
  </article>
{/if}
